export class Provider {
    public from:string;
    public providerId:EMAILPROVIDERS;
    public clientId:String;
    public setting:SendGrid | Smtp;
    public isDefault:boolean;
    public map(source: SendGrid|Smtp): void {
        Object.keys(source).map((key, index) => {
          this.setting[key] = source[key];
        });
      }
}
export class SendGrid {
 public apikey:string
}
export class Smtp{
    public host:String;
    public port:String;
    public username:String;
    public password:String;

}

export enum EMAILPROVIDERS{
   SENDGGRID=1,
   SMTP=2
}